module.exports = __webpack_public_path__ + "img/pcba_11@2x.70683397.png";